import React from 'react';
import styles from './Health.module.css';

const Health = ({ lang }) => {
  const data = {
    EN: {
      title: "Health & Wellness",
      btn: "Read More Health Tips",
      items: [
        { cat: "Nutrition", title: "The power of plant-based diet", desc: "How changing your meals can boost your energy levels significantly." },
        { cat: "Mental Health", title: "Mindfulness and daily stress", desc: "Simple techniques to maintain peace in a busy 2026 lifestyle." },
        { cat: "Fitness", title: "The 30-minute workout guide", desc: "Scientific approach to stay fit with limited time." }
      ]
    },
    UR: {
      title: "صحت اور تندرستی",
      btn: "مزید ہیلتھ ٹپس پڑھیں",
      items: [
        { cat: "غذائیت", title: "سبزیوں پر مبنی خوراک کی طاقت", desc: "مستقل طور پر اپنی خوراک کو بدل کر اپنی توانائی کو کیسے بڑھایا جائے۔" },
        { cat: "ذہنی صحت", title: "مائنڈ فلنس اور روزانہ کا تناؤ", desc: "مصروف زندگی میں سکون برقرار رکھنے کے سادہ طریقے اور تکنیکیں۔" },
        { cat: "فٹنس", title: "30 منٹ کا ورزش گائیڈ", desc: "محدود وقت میں فٹ رہنے کے لیے سائنسی طریقہ کار۔" }
      ]
    }
  }[lang];

  return (
    <section className={styles.healthSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.healthGrid}>
        {data.items.map((item, i) => (
          <div key={i} className={styles.healthCard}>
            <div className={styles.imgBox}>
              <img src={`https://picsum.photos/400/300?random=${i + 4000}`} alt="health" />
            </div>
            <div className={styles.content}>
              <span className={styles.tag}>{item.cat}</span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.moreBtnWrapper}>
        <button className={styles.moreBtn}>{data.btn}</button>
      </div>
    </section>
  );
};

export default Health;